import { render, staticRenderFns } from "./TeethDiagram.vue?vue&type=template&id=485466f2&scoped=true"
import script from "./TeethDiagram.vue?vue&type=script&lang=js"
export * from "./TeethDiagram.vue?vue&type=script&lang=js"
import style0 from "./TeethDiagram.vue?vue&type=style&index=0&id=485466f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "485466f2",
  null
  
)

export default component.exports